


























import Vue, { PropType } from "vue";
import "@/components/icons";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "UniversitySelectBox",
  model: {
    prop: "selectedUniversityId",
    event: "input"
  },
  props: {
    selectedUniversityId: {
      type: Number,
      required: true
    },
    distinctUniversities: {
      type: Array as PropType<Props["distinctUniversities"]>,
      required: true
    }
  },
  computed: {
    label() {
      if (
        !this.distinctUniversities ||
        !this.distinctUniversities.length ||
        !this.selectedUniversityId
      ) {
        return "";
      }
      const selectedUniversity = this.distinctUniversities.find(
        e => e.id === this.selectedUniversityId
      );
      if (!selectedUniversity || !selectedUniversity.name) return "";
      return selectedUniversity.name;
    }
  },
  methods: {
    updateSelectedUniversityId(event) {
      const universityId = Number(event.target.value);
      this.$emit("input", universityId);
    }
  }
});
